export enum PaymentRequestStatus {
  open = 'open',
  cancelled = 'cancelled',
  limitReached = 'limitReached',
  expired = 'expired'
}
